import React, { useEffect } from "react";

import FASTable from "../../../../../components/Tables/FASTable";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import {
  CustomerOutstanding,
  CustomerProOutstanding,
  CustomerSupplierProAcDetail,
} from "../../../../../Redux/Slice/Fas/Profile Analysis/Customer/CustomerSlice";
import { Loader } from "../../../../../components/Loader/Loader";
import { useTheme } from "../../../../../Themecontext/Themecontext";

export default function OutStanding({
  accountName,
  accountGroup,
  startDate,
  endDate,
}) {
  const dispatch = useDispatch();
  const { Colourdata } = useSelector((state) => state.ClientLogin);
  const { CustomerOutstandingdata } = useSelector(
    (state) => state.CustomerSlice,
  );

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );
  const { SupplierOutstandingdata } = useSelector(
    (state) => state.SupplierSlice,
  );
  const { theme } = useTheme();
  const isdark = theme;

  const Firm = Cookies.get("Firm");
  const YearId = Cookies.get("FinancialYear");

  useEffect(() => {
    dispatch(CustomerOutstanding());
    dispatch(
      CustomerProOutstanding({
        Firm,
        Year: YearId,
        AcIDs: accountName.join(","),
        selectedIds: accountGroup.join(","),
      }),
    );
    dispatch(CustomerSupplierProAcDetail({ AcIDs: accountName }));
  }, [dispatch, Firm, YearId, accountName]);

  function formatDateToDDMMYYYY(isoString) {
    if (!isoString) return "";

    const dateObj = new Date(isoString);
    if (isNaN(dateObj)) return ""; // Invalid date guard

    const day = String(dateObj.getDate()).padStart(2, "0");
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const year = dateObj.getFullYear();

    return `${day}/${month}/${year}`;
  }

  const getRows = CustomerOutstandingdata?.Detail?.map((label, index) => ({
    chart: true,
    // srNumber: index + 1,
    VouDate: formatDateToDDMMYYYY(label.VouDate),
    VouNo: label.VouNo,
    TransactionName: label.TransactionName,
    Amount: label.Amount,
    Adjustment: label.Adjustment,
    Discount: label.Discount,
    Interest: label.Interest,
    NetBalance: label.NetBalance,
    CumulativeBalance: label.CumulativeBalance,
    OsDays: label.OsDays,
    AcName: label.AcName,
  }));

  const getColumns = [
    { label: "Chart", key: "charts", align: "center" },
    { label: "Sr. No.", key: "srNumber", align: "center" },
    { label: "Vou No", key: "VouNo", align: "right" },
    { label: "Vou Date", key: "VouDate", align: "center" },
    {
      label: "Transaction Name",
      key: "TransactionName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Amount", key: "Amount", align: "right", format: "true" },
    { label: "Adjustment", key: "Adjustment", align: "right", format: "true" },
    { label: "Discount", key: "Discount", align: "right", format: "true" },
    { label: "Interest", key: "Interest", align: "right", format: "true" },
    {
      label: "Balance",
      key: "NetBalance",
      align: "right",
      format: "true",
    },
    {
  label: "Cumulative Balance",
  key: "CumulativeBalance",
  align: "right",
  format: "true",
},
    { label: "Os Days", key: "OsDays", align: "right" },
  ];
  if (CustomerOutstandingdata === "no" || CustomerOutstandingdata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }

  return (
    <div style={{ marginTop: "20px" }}>
      <div
        style={{
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
        }}
      >
        <div
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour4,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour11,
            padding: "14px",
            margin: 0,
          }}
        >
          <h2
            style={{
              fontSize: "18px",
              margin: 0,
              letterSpacing: "1px",
              fontWeight: "600",
            }}
          >
            OUTSTANDING
          </h2>
        </div>
        <FASTable data={getRows} columns={getColumns} />
      </div>
    </div>
  );
}
